<template>
  <section class="split-text">
    <div class="section-wrap">
      <Header dark :trigger="trigger"/>
    </div>
    <div class="container container--flex">
      <h1 class="split-text__head">frederik nordahl has 10 years of experience within web development, specialised in vue and react.</h1>
      <p class="split-text__text">through experience working for startups, large corporates and various agencies, frederik has gained great insight in the full package of web development. focusing on javascript and frameworks such as react and vue makes him a great asset for any web based project you may have</p>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'FrederikCases',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Frederik/Frederik.vue